if (!customElements.get('promo-popup')) {
  class PromoPopup extends HTMLElement {
    constructor() {
      super();

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      this.cookieName = 'beyours:promo-popup';
      this.country = ''
      this.classes = {
        bodyClass: 'promo-popup--open',
        activeClass: 'is-active',
        showImage: 'show-image',
      };

      // Open modal if errors or success message exist
      if (this.querySelector('.form__message')) {
        this.open();
      }

      this.querySelectorAll('.popup-close, .popup-overlay').forEach((button) => {
        button.addEventListener('click', this.close.bind(this));
      });

      this.querySelectorAll('.popup-open').forEach((button) => {
        button.addEventListener('click', this.open.bind(this));
      });

      document.querySelectorAll('[href="#open-popup"]').forEach((button) => {
        button.addEventListener('click', this.open.bind(this));
      });

      if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
        this.init();
      }

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) =>
          filterShopifyEvent(event, this, () => this.open.bind(this))
        );
        document.addEventListener('shopify:section:select', (event) =>
          filterShopifyEvent(event, this, this.open.bind(this))
        );
        document.addEventListener('shopify:section:deselect', (event) =>
          filterShopifyEvent(event, this, this.close.bind(this))
        );
      }

      this.getCountry();
    }

    getCountry() {
      const ipAddressEndpoint = 'https://api.ipify.org?format=json';
      fetch(ipAddressEndpoint)
        .then((response) => response.json())
        .then((data) => {
          //test ip address for norway 104.132.142.0
          const ipAddress = data.ip;
          // const ipAddress = '104.132.142.0';

          console.log(ipAddress);

          // Make a request to get the country using the IP address
          return fetch(`https://api.country.is/${ipAddress}`);
        })
        .then((response) => response.json())
        .then((countryData) => {
          const country = countryData.country;

          if (country.includes('NO')) {
            console.log(country)
            document.querySelector('promo-popup').open();
          } else {
            console.log("Not Norway");
          }

          this.country = country;
          if (country == 'NO') {
            this.open()
          }

        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    init() {
      if ((Shopify && Shopify.designMode) || true) {
        return;
      }

      setTimeout(
        function () {
          this.open();
        }.bind(this),
        parseInt(this.dataset.delay) * 1000
      );
    }

    open(evt) {
      if (evt) {
        try {
          evt.preventDefault();
        } catch (e) {
          console.log(e);
        }
      }

      document.body.classList.remove(this.classes.bodyClass);
      this.classList.add(this.classes.activeClass);
      setTimeout(() => {
        this.classList.add(this.classes.showImage);
      }, 200);

      if (this.dataset.position === 'center') {
        setScrollbarWidth();
        document.body.classList.add(this.classes.bodyClass);
      }

      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }

    close(event) {
      console.log('event', event);
      this.classList.remove(this.classes.activeClass);

      setTimeout(() => {
        this.classList.remove(this.classes.showImage);

        if (this.dataset.position === 'center') {
          document.body.classList.remove(this.classes.bodyClass);
        }
      }, 150);

      // Remove a cookie in case it was set in test mode
      if (this.dataset.testMode === 'true') {
        this.removeCookie(this.cookieName);
        return;
      }

      this.setCookie(this.cookieName, this.dataset.expiry);
    }

    getCookie(name) {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    }

    setCookie(name, expiry) {
      document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
    }

    removeCookie(name) {
      document.cookie = `${name}=; max-age=0`;
    }
  }
  customElements.define('promo-popup', PromoPopup);
}